import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-caretleft",
  "use": "icon-th-caretleft-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-caretleft\">\n<path d=\"M20.7075 25.2924C20.8004 25.3854 20.8741 25.4957 20.9244 25.6171C20.9747 25.7384 21.0006 25.8686 21.0006 25.9999C21.0006 26.1313 20.9747 26.2614 20.9244 26.3828C20.8741 26.5042 20.8004 26.6145 20.7075 26.7074C20.6146 26.8004 20.5043 26.8741 20.3829 26.9243C20.2615 26.9746 20.1314 27.0005 20 27.0005C19.8686 27.0005 19.7385 26.9746 19.6171 26.9243C19.4957 26.8741 19.3854 26.8004 19.2925 26.7074L9.29249 16.7074C9.19952 16.6146 9.12576 16.5043 9.07543 16.3829C9.02511 16.2615 8.99921 16.1314 8.99921 15.9999C8.99921 15.8685 9.02511 15.7384 9.07543 15.617C9.12576 15.4956 9.19952 15.3853 9.29249 15.2924L19.2925 5.29245C19.4801 5.10481 19.7346 4.99939 20 4.99939C20.2654 4.99939 20.5199 5.1048 20.7075 5.29245C20.8951 5.48009 21.0006 5.73458 21.0006 5.99995C21.0006 6.26531 20.8951 6.5198 20.7075 6.70745L11.4137 15.9999L20.7075 25.2924Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-caretleft.svg
// module id = yv6h
// module chunks = 83